import { render, staticRenderFns } from "./kanbanList.vue?vue&type=template&id=027134ec&"
import script from "./kanbanList.vue?vue&type=script&lang=js&"
export * from "./kanbanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports